<!-- Search Bar -->
<div class="w-full max-w-sm">
  <!-- Label -->
  @if (label) {
    <label
      [for]="id || inputId"
      [class]="labelClasses"
      class="flex items-center"
    >
      <span class="text-white">{{ label }}</span>
      @if (required) {
        <span class="text-destructive">*</span>
      }

      @if (help) {}
    </label>
  }

  <!-- Input Container -->
  <div class="relative w-full max-w-sm">
    <ui-input
      #inputRef
      [elementId]="id || inputId"
      [type]="type"
      [name]="name"
      [placeholder]="placeholder || 'Buscar...'"
      [disabled]="disabled"
      [readonly]="readonly"
      [required]="required"
      [tabindex]="tabindex"
      [autocomplete]="autocomplete"
      [spellcheck]="spellcheck ?? false"
      [value]="value"
      [ariaLabel]="ariaLabel"
      [attr.aria-describedby]="getAriaDescribedBy()"
      [dataTestId]="dataTestId"
      [variant]="hasError ? 'error' : 'default'"
      [customClasses]="resolvedUiInputClasses"
      [customContainerClasses]="resolvedUiInputContainerClasses"
      (inputInput)="onUiInput($event)"
      (inputChange)="onUiChange($event)"
      (inputFocus)="onUiFocus($event)"
      (inputBlur)="onUiBlur($event)"
      (inputKeyDown)="onUiKeyDown($event)"
      (inputKeyUp)="onUiKeyUp($event)"
      (inputClick)="onUiClick($event)"
      (inputMouseEnter)="onUiMouseEnter($event)"
      (inputMouseLeave)="onUiMouseLeave($event)"
    />

    @if (isStringWithValue()) {
      <button
        type="button"
        class="absolute right-10 top-1/2 z-10 -translate-y-1/2 text-gray-400 hover:text-white bg-transparent p-0.5 rounded-full focus:outline-none flex items-center justify-center"
        (click)="clear(); focus()"
        tabindex="-1"
        aria-label="Limpiar búsqueda"
      >
        <mat-icon class="!text-[14px] !w-[14px] !h-[14px] !leading-[14px]"
          >close</mat-icon
        >
      </button>
    }

    <span [class]="searchButtonWrapperClasses">
      <button
        type="button"
        class="flex items-center justify-center bg-transparent w-full h-full"
        (click)="onSearchClick()"
      >
        <mat-icon
          class="text-gray-200 !text-[14px] !w-[14px] !h-[14px] !leading-[14px]"
          >search</mat-icon
        >
      </button>
    </span>

    <!-- Helper Text -->
    @if (helperText && !hasError) {
      <div [class]="helperTextClasses">
        {{ helperText }}
      </div>
    }

    <!-- Error Messages -->
    @if (hasError && errorMessages) {
      <div [class]="errorTextClasses">
        <div class="flex items-center">
          {{ errorMessages }}
        </div>
      </div>
    }
  </div>
</div>
